import { useState, type ReactNode } from "react";
import { HeaderContext } from "./header.context";

interface HeaderRootProps {
  children: Readonly<ReactNode>;
}

export default function HeaderRoot({ children }: HeaderRootProps) {
  const [burger, setBurger] = useState(false);

  return (
    <HeaderContext.Provider value={{ burger: burger, setBurger }}>
      {children}
    </HeaderContext.Provider>
  );
}
